export default "__VITE_ASSET__c292c45f__"